export enum UpsellType {
  INCART = "INCART",
  PRECART = "PRECART",
}
